function noSpecialCharacters(e) {
  const char = String.fromCharCode(e.keyCode)
  if (/^\d*\.?\d*$/.test(char)) return true
  e.preventDefault()
  return false
}

export default {
  mounted(el) {
    el.addEventListener('keypress', noSpecialCharacters)
  },
  unmounted(el) {
    el.removeEventListener('keypress', noSpecialCharacters)
  },
}
